import { assumeInitialized } from "./base";

export class RRRFieldWithValidation extends HTMLElement {
  static tagName = "rrr-field-with-validation";

  inputElement: HTMLInputElement = assumeInitialized();
  errorElement: HTMLElement | null = null;

  constructor() {
    super();
    this.addEventListener("change", () => this.onChange());
  }

  connectedCallback() {
    this.inputElement = this.querySelector("input")!;
    this.errorElement = this.querySelector(".validation-message");
  }

  private setErrorMessage(message: string) {
    if (!this.errorElement) {
      this.errorElement = document.createElement("div");
      this.errorElement.classList.add("validation-message");
      this.appendChild(this.errorElement);
    }

    this.errorElement.innerText = message;
  }

  private clearErrorMessage() {
    if (this.errorElement) {
      this.removeChild(this.errorElement);
      this.errorElement = null;
    }
  }

  private onChange() {
    if (this.inputElement.validity.valid) {
      this.clearErrorMessage();
    } else {
      this.setErrorMessage(this.inputElement.validationMessage);
    }

    if (this.querySelector(":valid, :user-invalid")) {
      // on first real user interaction, always clear out the server-rendered
      // error class name as client-side validation has now taken over
      this.classList.remove("form-card__field--errors");
    }
  }
}
